var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 33",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.75c.28 5.418 1.04 7.922 2.284 10.063C8.149 23.023 12.2 26.192 14 27c1.826-.808 5.85-3.977 7.716-7.188C22.96 17.672 23.721 15.168 24 9.75c-5.184.016-7.368-1.833-10-3.75-2.632 1.917-4.816 3.766-10 3.75z"
  })));
}

export default SvgShieldIcon;